import "./intro.css";
import Me from "../../img/phone.png";

const Intro = () => {
  return (
    <div className="i">
      <div className="i-left">
        <div className="i-left-wrapper">
          <h2 className="i-intro">Assalamu Alaykum, My name is</h2>
          <h1 className="i-name">Fariha Hasan Kathika</h1>
          <div className="i-title">
            <div className="i-title-wrapper">
              <div className="i-title-item">Front end Developer</div>
              <div className="i-title-item">Web Developer</div>
              <div className="i-title-item">Working with React</div>
             
            </div>
          </div>
          <p className="i-desc">
            I develop wesite design for customers of all sizes,
            specializing in creating  modern websites and web services.
          </p>
        </div>
        {/* <a  style={{marginTop:'auto'}} href="https://drive.google.com/uc?export=download&id=1ZvFws-CyMuZ6mPtnw3N35NDhkeM9bx2e" target="_blank"><button>Download resume</button></a> */}
      
      </div>
      <div className="i-right">
        <div className="i-bg"></div>
        <img src="https://i.ibb.co/2gsz61J/myconvopic-removebg-preview.png" alt="" className="i-img" />
       
      </div>
    </div>
  );
};

export default Intro;
